<template>
  <div class="tableTil">
    <h4>
      <p>
        <img src="../../assets/images/logo.png" />
      </p>
      <p><span>充电订单一览表</span></p>
      <p>
        <span>{{ formattedTime }} {{ formattedWeekday }}</span><span>数据刷新时间{{ time(mins) }}分钟</span>
      </p>
    </h4>
    <!-- chargingList v-loadmore="loadmore"-->
    <el-card style="background: #306ac8; width: 98%; margin: 0 1%">
      <el-table :data="Alllist.slice(0, this.queryInfo.page * this.queryInfo.limit)" height="800px" border
        :header-cell-style="titleMethods" stripe @mouseenter.native="autoScroll(true)"
        @mouseleave.native="autoScroll(false)" empty-text="暂无电桩数据" ref="tableRef">
        <el-table-column align="center" label="充电桩编号-序号">
          <template slot-scope="scope">
            <span>{{ typeName(scope.row.pileCode) }}</span>
            <i class="el-icon-minus" style="font-weight: bolder;font-size: 14px;margin:0 10px 0 20px;color:#000"></i>
            <span>
              {{ scope.row.pileNo + '号桩' }}
              {{ scope.row.gunNumber == 1 ? 'A' : 'B' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="充电用户" prop="user">
          <template slot-scope="scope">
            <span>{{ typeName(scope.row.user) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="车牌号" prop="carNum">
          <template slot-scope="scope">
            <span>{{ typeName(scope.row.carNum) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="启动方式" prop="startType" width="140">
          <template slot-scope="scope">
            <span>{{ startTypeName(scope.row.startType) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="电量" prop="electric" width="140">
          <template slot-scope="scope">
            <span>{{ jisuan(scope.row.electric, 100, 2) }} 度</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="功率" prop="chargeKwh" width="160">
          <template slot-scope="scope">
            <span>{{ jisuans(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Soc" prop="startSoc" width="180">
          <template slot-scope="scope">
            <span>{{ typeName(scope.row.startSoc) }}%</span>
            <i class="el-icon-minus" style="font-weight: bolder;font-size: 16px;margin:0 10px 0 20px;color:#000"></i>
            <span>{{ typeName(scope.row.nowSoc) }}%</span>
          </template>
        </el-table-column>
        <el-form-item label="扣款方式：">
          <template slot-scope="scope">
            <span>{{ typeNames(scope.row) }}</span>
          </template>
        </el-form-item>
        <el-table-column align="center" label="启动时间" prop="Times" width="130">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.Times) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" prop="gunState" width="120px">
          <template slot-scope="scope">
            <el-tag :text="typeIng(
          scope.row.commStatus,
          scope.row.gunState,
          scope.row.gunToCarState
        )
          " :type="typeIngs(
          scope.row.commStatus,
          scope.row.gunState,
          scope.row.gunToCarState
        )
          ">
              {{
          typeIng(
            scope.row.commStatus,
            scope.row.gunState,
            scope.row.gunToCarState
          )
        }}</el-tag>
          </template>
        </el-table-column>
        <div slot="empty" class="empty">
          <span>暂无数据</span>
        </div>
      </el-table>

      <div class="footer">
        <p>
          <span>共</span>
          <b>{{ total }}</b>
          <span>枪&emsp;:</span>
        </p>
        <p>
          <b>{{ chongdian }}</b>
          <span>充电</span>
        </p>
        <p>
          <b>{{ lixian }}</b>
          <span>离线</span>
        </p>
        <p>
          <b>{{ kongxian }}</b>
          <span>空闲</span>
        </p>
        <p>
          <b>{{ guzhang }}</b>
          <span>故障</span>
        </p>
        <p>
          <b>{{ daibaqiang }}</b>
          <span>待拔枪</span>
        </p>
        <p>
          <b>{{ zhanyong }}</b>
          <span>占用</span>
        </p>
      </div>
      <!-- <div v-if="loading" class="loading-tip">加载中...</div>
      <div v-if="!hasMore" class="no-more">没有更多数据了</div> -->
      <!-- 分页导航区域 -->
      <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.page" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination> -->
    </el-card>
  </div>
</template>
<script>
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      threshold: 100,
      loading: false,
      hasMore: true,
      chargingList: [],
      total: 0,
      queryInfo: {
        page: 1,
        limit: 50,
      },
      uuId: '',
      currentTime: new Date(),
      mins: 60000,
      timer: null,
      scrollTimer: null,
      setTime: null,
      Alllist: [],
      billList: [],
      times: null
    }
  },
  computed: {
    lixian() {
      return this.Alllist.filter((item) => item.commStatus == 0).length || 0;
    },
    zhanyong() {
      return this.Alllist.reduce((count, item) => {
        if (item.gunState == 0 && item.gunToCarState !== 0) {
          return count + 1;
        }
        return count;
      }, 0);
    },
    kongxian() {
      return this.Alllist.reduce((count, item) => {
        if (item.gunState == 0 && item.gunToCarState == 0) {
          return count + 1;
        }
        return count;
      }, 0);
    },
    guzhang() {
      const objj = [4, 5, 6, 7];
      return this.Alllist.filter((item) => objj.includes(item.gunState)).length || 0;
    },
    daibaqiang() {
      return this.Alllist.reduce((count, item) => {
        if (item.gunState == 3) {
          return count + 1;
        }
        return count;
      }, 0);
    },
    chongdian() {
      return this.billList.length;
    },
    typeNames() {
      return function (val) {
        const { cardsType } = val
        switch (Number(cardsType)) {
          case 0:
            return '账户余额'
          case 1:
            return '亲情钱包'
          case 2:
            return '即充即退'
          case 3:
            return '绑定金额'
          case 4:
            return '离线刷卡'
          case 5:
            return '在线刷卡'
          case 6:
            return '超级卡'
          case 7:
            return 'VIN'
          case 8:
            return '其他'
          case 9:
            return '互联互通'
          default:
            return '未知类型'
        }
      }
    },
    startTypeName() {
      const objj = {
        0: '微信',
        9: '微信',
        1: '在线卡',
        2: '离线卡',
        3: '管理卡',
        4: 'Vin',
        5: 'hlht',
        6: '支付宝',
        7: 'App',
        8: 'ocpp_App',
      }
      return (obj) => {
        return objj[obj] || '无'
      }
    },
    jisuans() {
      return function (val) {
        return !val.chargeKwh ||
          val.chargeKwh == ''
          ? 0
          : val.pileType !== 5
            ? (val.chargeKwh / 100000).toFixed(4)
            : val.chargeKwh
      }
    },
    typeIng() {
      return function (commStatus, gunState, gunToCarState) {
        if (commStatus == 0) return '离线'
        if (gunState == 0) {
          return gunToCarState !== 0 ? '占用' : '空闲'
        }
        const objj = [4, 5, 6, 7]
        return objj.includes(gunState)
          ? '故障'
          : gunState == 3
            ? '待拔枪'
            : '充电'
      }
    },
    typeIngs() {
      return function (commStatus, gunState, gunToCarState) {
        if (commStatus == 0) return 'info'
        if (gunState == 0) {
          return gunToCarState !== 0 ? 'warning' : 'primary'
        }
        const objj = [4, 5, 6, 7]
        return objj.includes(gunState)
          ? 'error'
          : gunState == 3
            ? 'warning'
            : 'success'
      }
    },
    time() {
      return (obj) => {
        return obj == null || obj == '' ? '--' : (obj / 1000 / 60).toFixed(2)
      }
    },
    formattedWeekday() {
      const weekdays = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ]
      return weekdays[this.currentTime.getDay()]
    },
    formattedTime() {
      const year = this.currentTime.getFullYear()
      const month = String(this.currentTime.getMonth() + 1).padStart(2, '0')
      const day = String(this.currentTime.getDate()).padStart(2, '0')
      let hours = this.currentTime.getHours()
      let ampm = ''
      if (!this.show24HourFormat) {
        ampm = hours >= 12 ? ' PM' : ' AM'
        hours = hours % 12
        hours = hours ? hours : 12
      }
      const minutes = String(this.currentTime.getMinutes()).padStart(2, '0')
      const seconds = String(this.currentTime.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${String(hours).padStart(
        2,
        '0'
      )}:${minutes}:${seconds}${ampm}`
    },
    typeName() {
      return (obj) => {
        return obj == null || obj == '' || obj == undefined ? '--' : obj
      }
    },
    stareName() {
      return (obj) => {
        return obj == null || obj == '' || obj == undefined
          ? '--'
          : obj.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
      };
    },
    jisuan() {
      return (obj, num, fixed) => {
        return obj == null || obj == '' || obj == undefined
          ? '--'
          : (obj / num).toFixed(fixed)
      }
    },
  },
  watch: {
    chargingList(newval) {
      this.chargingList = newval;
    },
    Alllist(newval) {
      this.Alllist = newval;
      console.log(this.Alllist,348);
    },
  },
  beforeCreate() { },
  created() {
    this.uuId = this.$route.fullPath.split('/tableTil/')[1]
    this.com1()
    this.timer = setInterval(() => {
      this.currentTime = new Date()
    }, 1000)
    this.$http.get('sysConfig/getSysConfigBOById/83').then((ress) => {
      const res = ress.data
      this.mins = res.code == 0 ? Number(res.data.valueName) : 60000
      this.times = setInterval(() => this.loadmore(), this.mins)
    })
  },

  mounted() {
    if (this.uuId == null || this.uuId == '') return
    this.setTime = setInterval(() => this.com2(), this.mins)
  },

  beforeDestroy() {
    if (this.com2) {
      clearInterval(this.setTime)
    }
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.times) {
      clearInterval(this.times)
    }
  },
  methods: {
    com2() {
      const that = this
      that.$http
        .get(`17AC33DA36054CB7B07FC5FD75089D4FPRH6GWQK/${that.uuId}`)
        .then((ress) => {
          const res = ress.data
          if (res.code > 0) return
          // 订单列表
          that.billList = res.data.flatMap((item) => item.billList || []);
          if (that.billList.length > that.chargingList.length) return
          // 使用双重循环查找匹配项
          that.chargingList.forEach((element, i) => {
            that.billList.forEach((til) => {
              // 修正原代码中错误的数组访问方式
              if (
                element.pileCode === til.pileCode &&
                element.gunNumber === til.gunNumber
              ) {
                element.user = til.phone
                element.icCode = til.icCode
                element.carNum = til.carNum
                element.carvin = til.carvin
                element.startSoc = til.startSoc
                element.startType = til.startType
                element.nowSoc = til.nowSoc
                element.electric = til.totalKwh
                element.Times = til.startTime
                element.chargeKwh = til.chargeKwh
                element.cardsType = til.cardsType
                that.$set(
                  that.chargingList[i],
                  that.chargingList[i].user,
                  til.phone
                )
                that.$set(
                  that.chargingList[i],
                  that.chargingList[i].cardsType,
                  til.cardsType
                )
                that.$set(
                  that.chargingList[i],
                  that.chargingList[i].icCode,
                  til.icCode
                )
                that.$set(
                  that.chargingList[i],
                  that.chargingList[i].startSoc,
                  til.startSoc
                )
                that.$set(
                  that.chargingList[i],
                  that.chargingList[i].carNum,
                  til.carNum
                )
                that.$set(
                  that.chargingList[i],
                  that.chargingList[i].carvin,
                  til.carvin
                )
                that.$set(
                  that.chargingList[i],
                  that.chargingList[i].startType,
                  til.startType
                )
                that.$set(
                  that.chargingList[i],
                  that.chargingList[i].nowSoc,
                  til.nowSoc
                )
                that.$set(
                  that.chargingList[i],
                  that.chargingList[i].electric,
                  til.totalKwh
                )
                that.$set(
                  that.chargingList[i],
                  that.chargingList[i].Times,
                  til.startTime
                )
                that.$set(
                  that.chargingList[i],
                  that.chargingList[i].chargeKwh,
                  til.chargeKwh
                )
              }
            })
          })
        })
    },
    autoScroll(stop) {
      const table = this.$refs.tableRef
      const bodyWrapper = table.$refs.bodyWrapper
      if (stop) {
        clearInterval(this.scrollTimer)
      } else {
        this.scrollTimer = setInterval(() => {
          bodyWrapper.scrollTop += 125
          if (
            bodyWrapper.scrollTop + bodyWrapper.clientHeight >=
            bodyWrapper.scrollHeight
          ) {
            bodyWrapper.scrollTop = 0
          }
        }, 5000) // 每30ms滚动1px
      }
    },
    loadmore() {
      this.queryInfo.limit += 50
      this.handleSizeChange()
    },
    titleMethods({ row, column, rowIndex, columnIndex }) {
      return 'background:	#3B82F6; color:#fff;fontSize:24px'
    },
    // 监听pageSize改变的事件
    handleSizeChange() {
      // pageSize
      // 更新每页显示数量
      // this.queryInfo.limit = pageSize
      // 计算正确的分页区间（修正运算符优先级）
      const startIndex = (this.queryInfo.page - 1) * this.queryInfo.limit
      const endIndex = this.queryInfo.page * this.queryInfo.limit
      // 边界检查确保不超过数据范围
      const safeStart = Math.max(0, startIndex)
      const safeEnd = Math.min(this.Alllist.length, endIndex)
      // 更新当前页数据
      this.chargingList = this.Alllist.slice(safeStart, safeEnd)
      // 当前页数据
      // 可选：触发数据更新通知
      this.$emit('page-change', {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit,
      })
      this.com2()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      // 边界检查确保页码有效
      newPage = Math.max(
        1,
        Math.min(newPage, Math.ceil(this.Alllist.length / this.queryInfo.limit))
      )
      this.queryInfo.page = newPage
      // 计算正确的分页区间
      const startIndex = (newPage - 1) * this.queryInfo.limit
      const endIndex = newPage * this.queryInfo.limit
      // 更新当前页数据
      this.chargingList = this.Alllist.slice(startIndex, endIndex)
      this.$emit('page-change', {
        page: newPage,
        limit: this.queryInfo.limit,
      })
      this.com2()
    },
    // 获取电站列表数据
    getPowerStationList() {
      this.$http
        .get('station-info/getAllStationInfo', {
          params: {
            page: 1,
            limit: 50,
            stationIds: '26,27',
            roleId: 5,
            stationMode: '0,1,2',
          },
        })
        .then((ress) => {
          const res = ress.data
          if (ress.code > 0) return
          this.uuId = res.data
            .map((item) => {
              return item.uuId
            })
            .join(',')
          this.com1()
        })
    },
    com1() {
      // 获取充电桩所有信息
      this.$http
        .get(`08F468B0978D4152B9FF0FE07A51616A280XSH09/${this.uuId}`)
        .then((ress) => {
          const res = ress.data
          this.Alllist = res.data
            .flatMap((item) => item.pileList || [])
            .concat(
              Array(this.Alllist.length).fill({
                user: '',
                electric: '', // 修正拼写错误(eletric->electric)
                nowSoc: '',
                Times: '',
                chargeKwh: '',
                icCode: '',
                carNum: '',
                carvin: '',
                startType: '',
                startSoc: '',
                cardsType: ''
              })
            )
          this.total = this.Alllist.length
          this.handleCurrentChange(1)
        })
    },

    async getChargingOrderList() { },
    // 批量删除的复选框改变事件
    handleSelectionChange(value) {
      if (value.length > 0) {
        this.ids = ''
        value.forEach((item) => {
          this.ids += item.id + ','
        })
        this.ids = this.ids.substring(0, this.ids.length - 1)
      } else {
        return false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.tableTil {
  width: 100%;
  height: 100%;
  background: #306ac8;
  overflow-y: scroll;

  .footer {
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 20px;

    span {
      font-size: 18px !important;
      padding-right: 10px;
      font-weight: bolder;
    }

    b {
      font-size: 20px !important;

      padding-right: 10px;
    }

    p:first-child {
      margin-right: 30px;
    }

    p:nth-child(2) {

      b,
      span {
        color: #16ff7f;
      }
    }

    p:nth-child(3) {

      b,
      span {
        color: gray;
      }
    }

    p:nth-child(4) {

      b,
      span {
        color: #190aff;
      }
    }

    p:nth-child(5) {

      b,
      span {
        color: red;
      }
    }

    p:nth-child(6) {

      b,
      span {
        color: #fb923c;
      }
    }
  }

  ::v-deep {
    .el-table__empty-text .empty span {
      color: #fff;
      font-size: 24px !important;
    }

    .el-table .cell {
      line-height: 35px;

      span {
        font-size: 20px !important;
        font-weight: bolder !important;
      }
    }

    .el-table__empty-block {
      background: #306ac8;
    }

    .el-select {
      width: 180px;

      .el-input__inner {
        width: 180px !important;
        font-size: 20px !important;
        display: flex !important;
        flex-direction: row !important;
        justify-content: space-between !important;
      }
    }

    .el-input--mini .el-input__icon {
      color: #fff !important;
      font-size: 18px !important;
    }

    .el-icon el-icon-arrow-left {
      font-size: 18px !important;
    }

    .el-pagination .btn-next .el-icon,
    .el-pagination .btn-prev .el-icon {
      font-size: 18px;
    }

    .el-pagination button {
      width: 40px;
      height: 35px;

      .el-pagination span {
        line-height: normal;
        vertical-align: bottom;
        font-size: 20px !important;
        color: #fff;
      }
    }

    .el-pagination__total {
      color: #fff;
      font-size: 20px !important;
      vertical-align: bottom;
    }

    .el-pager li {
      width: 60px;
      height: 35px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .el-input__inner,
    html .el-input__inner,
    #app .el-input__inner {
      width: 120px !important;
      background: #3b82f6;
      color: #fff;
    }

    .el-pagination__jump {
      width: 240px;
      font-size: 18px !important;
      color: #fff;
    }
  }

  h4 {
    display: flex;
    padding: 0 1%;
    flex-direction: row;
    width: 98%;
    justify-content: space-between;

    p {
      height: 40px;
      display: flex;
      align-items: center;
      color: #fff;

      img {
        width: 240px;
        height: 60px;
      }
    }

    p:nth-child(2)>span {
      font-size: 32px !important;
    }

    p:nth-child(3) {
      flex-direction: column;

      span {
        flex: 1;
        color: #13ce66;
      }

      span:nth-child(1) {
        font-size: 24px !important;
      }

      span:nth-child(2) {
        color: #fff;
        font-size: 18px !important;
      }
    }
  }
}
</style>